import {type IAsset} from '@netx/core-asset-next/schema';
import {AssetViewName} from '@netx/core-asset-views';

export const assetHasPdf = (asset?: IAsset) => {
	if (!asset) return false;
	return (
		asset.fileFormatFamily.includes('document') &&
		(asset.viewNames.includes(AssetViewName.PDF) ||
			asset.filetypelabel === 'pdf')
	);
};

export default assetHasPdf;
